import React, { useState, useEffect } from "react";
import Header from "../../../commons/Header/Header";
import Sidebar from "../../../commons/Sidebar/Sidebar";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleApiCall } from "../../../apis";
import { endpoints } from "../../../utils/endpoints";

function ManagePincode() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [cms, setCms] = useState({ type: "publish" });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [pincodes, setPincodes] = useState([]);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const city_name = queryParams.get("city_name");
  const restaurantId = queryParams.get("restaurant_id");

  const fetchPincodes = async () => {
  try {
    setLoading(true);
    const response = await handleApiCall(
      "get",
      `${endpoints.restaurantDelivaryPinCodeList}?city_name=${city_name}&restaurant_id=${restaurantId}`
    );

    if (response?.data?.code === 200) {
      setPincodes(response.data.data);
    }
  } catch (error) {
    console.error("Error fetching pincodes:", error);
    setError(true);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  if (city_name) {
    fetchPincodes();
  }
}, [city_name]);

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Manage Pincode</h3>
            </div>
            <div className="d-flex">
              <div class="mt-3">
                <Link to='/menu-and-restaurant-management' class="btn btn-default rounded-lg">Back</Link>
              </div>
            </div>
            {/* <h5 className="mt-4">PINCODES OF LONDON</h5> */}
            <h5 className="mt-4">PINCODES OF {city_name?.toUpperCase()}</h5>
            <div className="row mx-n2 mt-4">
              {loading ? (
                <p>Loading...</p>
              ) : pincodes.length > 0 ? (
                pincodes.map((item) => (
                  <div className="form-group col-md-3 px-2" key={item._id}>
                    <input
                      type="text"
                      className="form-control rounded-3"
                      value={item.pin_code}
                      readOnly
                    />
                  </div>
                ))
              ) : (
                <p>No Pincode Found</p>
              )}
              
              {/* <div className="form-group col-md-3 px-2">
                <input type="text" name="" className="form-control rounded-3" value="E1 7AA"/>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManagePincode;
